import React,{useState} from "react";
import watchVideo from '../Images/watchVideo.jpg';
import CeoEucto from '../Images/CeoEucto.png';
import { IoMdPlayCircle } from "react-icons/io";
import baccdot from "../Images/BlaccdotVideo.mp4"; // video file
import {Zoom} from 'react-reveal'
import {Fade} from 'react-reveal'
import {useNavigate} from 'react-router-dom'

   
export default function WatchVideo() {
  const [showModal, setShowModal] = useState(false);
      const navigate = useNavigate();
  
    const handleGetStart = ()=>{
      sessionStorage.setItem('selectedService', 'Real Estate');
      sessionStorage.setItem('selectedSubService', 'India');
      sessionStorage.setItem('serviceid', 5);
      navigate('/selectrealEaste');
      
    }


  return (
  <div className="euctorap" style={{paddingTop:'50px'}}>
      {/* HERO CARD */}
       <Zoom bounce>
      <div className="container">
        <section className="heroCard" role="region" aria-label="Feature story">
          <div className="heroLeft">
            <p className="eyebrow">Behind every sale is the right connection,</p>
            <h1 className="heroTitle">Smart Leads</h1>
            <span className="accentBar" aria-hidden="true" />
            <a href="#" className="storyLink"  onClick={() => setShowModal(true)}>
              WATCH DEMO <span className="arrow" aria-hidden="true"><IoMdPlayCircle style={{fontSize:"25px"}}/></span>
            </a>
          </div>

    <div className="heroRight">
      {/* Background Image */}
      <img src={watchVideo} alt="Watch the story" className="heroImg"/>

      {/* Play Button */}
        <button
        className="playBtn"
        aria-label="Watch video"
        onClick={() => setShowModal(true)}
        style={{
            animation: "softZoom 2s infinite ease-in-out"
        }}
        >
        <span className="playTri" />
        </button>

      {/* Label */}
      <div className="watchLabel">WATCH VIDEO</div>
      <div className="imgGradient" aria-hidden="true" />
    </div>
        </section>
      </div>
</Zoom>
      {/* YELLOW BAND */}
      <section className="yellowBand" role="region" aria-label="blaccdot One CTA and testimonial">
        <div className="container yellowGrid">
          {/* Left: product copy */}
        <Fade left>
          <div className="leftCol">
            {/* <div className="logoRow">
              <img src="./blaccLogo.png" alt="" className="cubeLogo" />
              <span className="suiteSmall">All-in-one suite</span>
            </div> */}

            <h2 className="brandTitle">Blaccdot Canada</h2>
            <p className="subTitle">The Lead distributes system for business</p>
            <p className="desc">
                Blacdot intelligently distributes leads to your team, ensuring faster response times and higher conversion rates.
                Stop letting opportunities slip through the cracks.
                Start turning every prospect into a customer.</p>

            <div onClick={handleGetStart} className="ctaBtn">
              TRY BLACCDOT <span className="arrow" aria-hidden="true">→</span>
            </div>
          </div></Fade>

          <div className="divider" aria-hidden="true" />

          {/* Right: testimonial */}
        <Fade right>
          <div className="rightCol">
            <div className="quoteMark" aria-hidden="true">“</div>
            <p className="quoteText">
            Blaccdot One delivers critical value for startups, mid-sized companies, and large enterprises.
            </p>

            <div className="person">
              {/* <img src={CeoEucto} alt="" className="avatar" /> */}
              <div className="personMeta">
                <div className="name">Peter Christopher </div>
                <div className="role">Founder, CEO at Blaccdot</div>
              </div>
            </div>

            <div className="decorCube" aria-hidden="true" />
          </div></Fade>
        </div>
        {showModal && (
        <div className="videoModal" onClick={() => setShowModal(false)}>
          <div className="videoWrapper" onClick={(e) => e.stopPropagation()}>
            <video src={baccdot} controls autoPlay className="videoPlayer" />
          </div>
        </div>
      )}
      </section>
    </div>
  );
}
